<mat-slider class="mt-2" [disabled]="disabled" [invert]="invert" [max]="max" [min]="min" [step]="step"
    [thumbLabel]="thumbLabel" [tickInterval]="tickInterval" [(ngModel)]="value" [vertical]="vertical">
</mat-slider>